import { createFileRoute, useParams } from '@tanstack/react-router'
import TaskCommentsGallery from '../../../../../../../../../../../../../../containers/pin-details/components/task-list/task/comments-gallery.jsx'

function CommentsGalleryRouteComponent() {
  const { taskId } = useParams({ strict: false })

  return <TaskCommentsGallery taskId={taskId} />
}

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType/noPlan/$pinId/task/task-details/$taskId/comment-gallery/$fileId/$commentId/'
)({
  component: CommentsGalleryRouteComponent
})
